import { DEMO_MODE } from '../../constants';
import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import userDataReducer from './userDataReducer';

const persistConfig = {
  timeout: 0,
  key: DEMO_MODE ? 'demo-root' : 'root',
  storage,
  blacklist: ['userData'],
};

const userDataPersistConfig = {
  key: DEMO_MODE ? 'demo-userData' : 'userData',
  storage,
  blacklist: [
    'drawerOpen',
    'msg',
    'apiStatus',
    'apiData',
    'enquiryDetail',
    'loginBtnLoading',
    'registerBtnLoading',
    'patientBtnLoading',
    'consultationNoteBtnLoading',
    'appointmentBtnLoading',
    'appointmentInvoiceBtnLoading',
    'doctorBtnLoading',
    'userBtnLoading',
    'productBtnLoading',
    'productCategoryBtnLoading',
    'enquiryByMobileBtnLoading',
    'enquiryBtnLoading',
    'enquiryNoteBtnLoading',
    'labelBtnLoading',
    'incomeExpenseBtnLoading'
  ],
};


const rootReducer = combineReducers({
  userData: persistReducer(userDataPersistConfig, userDataReducer),
});

export default persistReducer(persistConfig, rootReducer);
